import { GoogleSheetsSyncPage, SyncType } from '../../components/GoogleSheetsSyncPage/GoogleSheetsSyncPage';
import { PageId } from '../../components/Sidebar/Sidebar';
import defaultSheets from '../../config/default_sheets';

const BuyerByProductSyncPage = () => {
  return (
    <GoogleSheetsSyncPage
      title="Sync Buyer By Product Data from Google Sheets"
      syncType={SyncType.BuyerByProduct}
      pageId={PageId.BuyerVendor}
      defaultSheetUrl={defaultSheets.BuyerByProduct.defaultSheetUrl}
      defaultRange={defaultSheets.BuyerByProduct.defaultRange}
    />
  );
};

export default BuyerByProductSyncPage;
